import React, { useState } from 'react'
import { Dialog, DialogContent, IconButton, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import RtoRiskCard from './RtoRiskCard'

// NETRA RTO band -> solid pill colour (hex). Higher score = more risk:
// green(low) -> red(high).
const BAND_COLOR = {
  GREEN: '#2e7d32',
  YELLOW: '#f9a825',
  ORANGE: '#ed6c02',
  RED: '#d32f2f',
  GREY: '#757575',
}

/**
 * Compact, colour-coded NETRA RTO-risk score for admin list views.
 * Shows the risk score (0–100) in a band-coloured pill; band on hover.
 * Renders nothing when the order hasn't been RTO-scored.
 *
 * When `orderId` is supplied the pill is clickable and opens a dialog with the
 * full RtoRiskCard (gauge + risk factors + advisory) — mirrors NetraScoreBadge.
 */
const RtoRiskBadge = ({ netra, orderId, scorePath, scoredStageNote }) => {
  const [open, setOpen] = useState(false)

  if (!netra || netra.score === null || netra.score === undefined) return null
  const score = Math.round(Number(netra.score))
  if (Number.isNaN(score)) return null
  const color = BAND_COLOR[netra.band] || '#616161'
  const clickable = Boolean(orderId)

  const handleOpen = (e) => {
    if (!clickable) return
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = (e) => {
    e?.stopPropagation?.()
    setOpen(false)
  }

  return (
    <>
      <Tooltip title={`RTO risk: ${netra.band || '—'} (${score}/100)${clickable ? ' · click for details' : ''}`} arrow>
        <span
          role={clickable ? 'button' : undefined}
          tabIndex={clickable ? 0 : undefined}
          onClick={handleOpen}
          onKeyDown={(e) => {
            if (clickable && (e.key === 'Enter' || e.key === ' ')) handleOpen(e)
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 30,
            height: 22,
            padding: '0 8px',
            borderRadius: 11,
            background: color,
            color: '#fff',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: '22px',
            letterSpacing: 0.2,
            cursor: clickable ? 'pointer' : 'default',
          }}
        >
          {score}
        </span>
      </Tooltip>

      {clickable && (
        <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth onClick={(e) => e.stopPropagation()}>
          <IconButton onClick={handleClose} size='small' sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
            <CloseIcon fontSize='small' />
          </IconButton>
          <DialogContent sx={{ p: 2 }}>
            {open && <RtoRiskCard netra={netra} orderId={orderId} scorePath={scorePath} scoredStageNote={scoredStageNote} />}
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default RtoRiskBadge
